// extracted by mini-css-extract-plugin
export default {"textarea":"RenderResults_textarea__z6Unp"};